import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { gsap } from "gsap";
import ProductCard from "./ProductCard";
import { WhiteButton } from "../Buttons";
import { FaAngleLeft, FaAngleRight, FaLongArrowAltRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { tabs } from "../../data/text";
function Collections({ cate, title, data, tagline, category }) {
  const [activeTab, setActiveTab] = useState("Trending");
  const slidesRef = useRef([]);
  const swiperRef = useRef(null);
  const buttonRef = useRef([]);
  const navigate = useNavigate();
  let filteredData = [];
  const handleTabs = (tabTitle) => {
    setActiveTab(tabTitle);
  };
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };
  return (
    <div className="bg-white pt-10 pb-0 md:pt-10 md:pb-20">
      <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center gap-10">
        {/* Left Side: Title & Tagline */}
        <div className="w-full lg:w-1/3 flex flex-col  gap-6 justify-center">
          <h2
            data-aos="fade-up"
            data-aos-delay="100"
            className="font-syne text-2xl md:text-5xl font-bold text-gradient-black"
          >
            {title}
          </h2>
          <p
            data-aos="fade-up"
            data-aos-delay="300"
            className="font-outfit  text-black text-[16px] font-light"
          >
            {tagline}
          </p>
          <WhiteButton
            title={"Shop the Collection"}
            handleClick={() => navigate(`/fragrance`)}
            icon={<FaLongArrowAltRight />}
            ref={(el) => (buttonRef.current[0] = el)}
          />
        </div>

        {/* Right Side: Slider */}
        <div className="w-full lg:w-2/3 relative">
          <div className="w-[100%] flex justify-center mb-5 items-cneter gap-[1rem] md:gap-[2rem]">
            {cate === "men" && (
              <>
                {tabs.map((tab, index) => {
                  const active = activeTab === tab.title;
                  filteredData = data?.filter((item) => {
                    if (!item.tags) return false;

                    return item.tags.includes(activeTab);
                  });

                  return (
                    <button
                      key={index}
                      onClick={() => handleTabs(tab.title)}
                      className={`w-[100px] py-[0.5rem] text-[14px] sm:text-[18px] font-semibold ${active ? "text-gray-800 border-b border-b-gray-800" : "text-gray-500 border-b border-b-gray-500"}   roundend-xl`}
                    >
                      {tab.title}
                    </button>
                  );
                })}
              </>
            )}
          </div>
          <div
            ref={sliderRef}
            className="flex overflow-x-auto scroll-smooth gap-4 px-2 snap-x snap-mandatory hide-scrollbar"
          >
            {cate === "men"
              ? filteredData?.map((item, index) => (
                  <ProductCard key={index} products={item} />
                ))
              : data?.map((item, index) => (
                  <ProductCard key={index} products={item} />
                ))}
          </div>

          {/* Custom Buttons */}
          <button
            onClick={scrollLeft}
            className="absolute top-1/2 left-0 lg:left-[-40px] w-10 h-10 lg:w-12 lg:h-12 bg-white rounded-full flex items-center justify-center transform -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
          >
            <FaAngleLeft className="text-black text-xl lg:text-2xl" />
          </button>

          <button
            onClick={scrollRight}
            className="absolute top-1/2 right-0 lg:right-[-60px] w-10 h-10 lg:w-12 lg:h-12 bg-white rounded-full flex items-center justify-center transform -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
          >
            <FaAngleRight className="text-black text-xl lg:text-2xl" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Collections;
